import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Form, Input, Radio } from 'antd'
import type { FormInstance } from 'antd'

const { TextArea } = Input

const { useForm } = Form

export const CONTACT_TYPES = [
  { label: 'contactEmail', value: 'contactEmail' },
  { label: 'contactPhone', value: 'contactPhone' },
]

const interestedInTypes = ['buying', 'financing', 'productDemo']

const useInitialProps = (values) => {
  const ref = useRef(null)

  if (values && ref.current === null) {
    ref.current = values
  }

  return ref.current
}

interface EnquiryFormProps {
  initialValues: {
    contactType?: string
  } | null
  isLoading?: boolean
  form?: FormInstance
}

const EnquiryForm = ({
  initialValues: initialValuesFromProps,
  isLoading,
  form: initialForm,
}: EnquiryFormProps) => {
  const [form] = useForm(initialForm)
  const { t } = useTranslation()
  const initialValues = useInitialProps(initialValuesFromProps)
  const [contactType, setContactType] = useState(initialValues?.contactType)

  const contactTypesTranslated = CONTACT_TYPES.map(({ label, value }) => ({
    label: t(`enquiryModal.form.contactType.${label}`),
    value,
  }))

  const validateMessages = {
    required: t('enquiryModal.form.validateMesages.required'),
    types: {
      email: t('enquiryModal.form.validateMesages.email'),
      phone: t('enquiryModal.form.validateMesages.phone'),
    },
  }

  const renderContactFormItem = (name) => {
    const contactFormItemRules = []
    const translatedLabel = t(`enquiryModal.form.contactType.${name}`)

    if (name !== '') {
      contactFormItemRules.push({
        required: true,
        message: t('enquiryModal.form.validateMesages.requiredCustom', {
          label: `${translatedLabel}`,
        }),
      })
    }

    if (name === 'contactEmail') {
      contactFormItemRules.push({ type: 'email' })
    }

    return (
      <Form.Item
        className="custom-form-item"
        messagevariables={{ translatedLabel }}
        name={name}
        rules={contactFormItemRules}
      >
        <Input
          disabled={isLoading}
          placeholder={t('enquiryModal.form.contact.placeHolder')}
        />
      </Form.Item>
    )
  }

  return (
    <Form
      className="enquiry-modal__form"
      form={form}
      initialValues={initialValues}
      layout="vertical"
      requiredMark={false}
      validateMessages={validateMessages}
    >
      <Form.Item
        className="custom-form-item custom-form-item--disabled"
        label={t('enquiryModal.form.companyName.label')}
        name="companyName"
      >
        <Input
          disabled
          placeholder={t('enquiryModal.form.companyName.placeHolder')}
        />
      </Form.Item>

      <Form.Item
        className="custom-form-item"
        label={t('enquiryModal.form.contactName.label')}
        name="contactName"
        rules={[{ required: true }]}
      >
        <Input
          disabled={isLoading}
          placeholder={t('enquiryModal.form.contactName.placeHolder')}
        />
      </Form.Item>

      <Form.Item
        className="custom-form-item"
        label={t('enquiryModal.form.contactType.label')}
        name="contactType"
        rules={[{ required: true }]}
      >
        <Radio.Group
          disabled={isLoading}
          options={contactTypesTranslated}
          onChange={(e) => setContactType(e.target.value)}
        />
      </Form.Item>

      {renderContactFormItem(contactType)}

      <Form.Item
        className="custom-form-item"
        label={t('enquiryModal.form.note.label')}
        name="note"
      >
        <TextArea
          disabled={isLoading}
          placeholder={t('enquiryModal.form.note.placeHolder')}
          rows={7}
          style={{ resize: 'none' }}
        />
      </Form.Item>

      <Form.Item
        className="custom-form-item test"
        name="serviceContact"
        valuePropName="checked"
      >
        <Checkbox disabled={isLoading}>
          {t('enquiryModal.form.isNeedOffer.label')}
        </Checkbox>
      </Form.Item>
    </Form>
  )
}

export { EnquiryForm, interestedInTypes }
